export const FEATURE_FLAGS = {
  NEW_HOME_DESIGN: 'feature_new_home_design',
  POSITION_EVOLUTION_CHART: 'feature_position_evolution_chart',
};

export const isFeatureEnabled = (flag) => {
  return localStorage.getItem(flag) === 'true';
};

export const toggleFeature = (flag) => {
  const current = isFeatureEnabled(flag);
  localStorage.setItem(flag, (!current).toString());
  return !current;
};

export const setFeature = (flag, value) => {
  localStorage.setItem(flag, value.toString());
};
